import { v4 as uuid } from 'uuid';
import { CustomColumnHeader, CustomColumnType, getColumnHeaderDataTypes } from 'types';
import {
  CustomHeaderKey,
  MatchedHeader,
} from '@components/bid_request/details/types';

const setDataTypeForCustomHeader = (templateKey?: string): string => {
  const dataTypes = getColumnHeaderDataTypes();

  switch (templateKey) {
    case 'descriptive_column_numeric':
      return dataTypes.NUMERIC;
    default:
      return dataTypes.TEXT; // Default to TEXT if no match
  }
};

/**
 * Build custom headers from matched headers
 * @param customHeaders {MatchedHeader[]} - Array of matched headers
 * @param headerType {String} - Type of header
 * @returns {[Partial<CustomColumnHeader>[], CustomHeaderKey[]]}
 */
export const buildCustomHeadersFromMatched = (
  customHeaders: MatchedHeader[],
  headerType: CustomColumnType
): [Partial<CustomColumnHeader>[], CustomHeaderKey[]] => {
  let columnOrderIndex = 0;

  const customHeadersCreated: Partial<CustomColumnHeader>[] = customHeaders
    .filter(col => col.sheet_column_name)
    .map(col => {
      columnOrderIndex += 1;
      return {
        column_order_index: columnOrderIndex,
        column_type: headerType,
        data_type: setDataTypeForCustomHeader(col?.template_column_key),
        display_text: col.sheet_column_name,
        id: `new-${uuid()}`,
        is_supplier_visible: true,
      };
    });

  const customHeaderKeysCreated: CustomHeaderKey[] = customHeaders
    .filter(col => col.sheet_column_name)
    .map((col, index) => ({
      dataType: setDataTypeForCustomHeader(col?.template_column_key),
      index: col.index,
      name: col.sheet_column_name,
      orderIndex: index + 1,
    }));

  return [customHeadersCreated, customHeaderKeysCreated];
};
